// Add this route wherever tenant-admin routes are registered (see
// ProtectedRoute.tsx, where an earlier pass already added a menu entry
// "سلسله‌مراتب سازمانی" under "سازمان و پیکربندی" — reuse that, don't
// duplicate it).

import { RouteObject } from "react-router-dom";
import { OrganizationHierarchyPage } from "./pages/OrganizationHierarchyPage";
import OrgHierarchyHelp from "./help/organization-hierarchy.mdx";
import OrgHomeHelp from "./help/organization.mdx";

export const organizationRoutes: RouteObject[] = [
  {
    path: "organization/hierarchy",
    element: <OrganizationHierarchyPage />,
  },
  {
    path: "help/organization/hierarchy",
    element: <OrgHierarchyHelp />,
  },
  {
    path: "help/organization/home",
    element: <OrgHomeHelp />,
  },
];
